import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { PushNotificationService } from 'src/app/modules/retailer/services/push-notification.service';

@Component({
  selector: 'app-create-push-notification-campaign',
  templateUrl: './create-push-notification-campaign.component.html',
  styleUrls: ['./create-push-notification-campaign.component.scss']
})
export class CreatePushNotificationCampaignComponent implements OnInit {

  public pageMode: string; // add/edit
  public pageTitle: string; 

  public loginData: any;
  public editPushNotificationCampaignDetails: any;

  public calendarConfig = { 
    adaptivePosition: true, 
    dateInputFormat: 'MMMM Do YYYY',  // YYYY-MM-DD | MMMM Do YYYY, h:mm:ss a
    containerClass: 'theme-default', 
    showWeekNumbers: false,
    //withTimepicker: true,
  };
  public calendarMinDate: Date;

  public pushNotificationTopics: any = [];
  public pushNotificationTopicsLoading: boolean = false;
  public selectedPushNotificationTopic: any = 0;

  public campaignName: string;
  public campaignDate: any;
  public pushNotificationTitle: string;
  public pushNotificationMessage: string;
  public pushNotificationImage = {
    file: null,
    base64: null,
    s3FilePath: null
  };

  public savingPushNotificationCampaign: boolean = false;
  public pushNotificationCampaignSaveConfirmModal: BsModalRef;
  public isDeletePushNotificationCampaign: boolean = false;
  
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _modalService: BsModalService,
    private _utilService: UtilService,
    private _pushNotificationService: PushNotificationService,
  ) {
    if(this._router.getCurrentNavigation().extras.state) {
      this.editPushNotificationCampaignDetails = this._router.getCurrentNavigation().extras.state.pushNotificationCampaign;
    }
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    // Calendar setings with timezone
    this.calendarMinDate = new Date(moment().format('YYYY-MM-DD HH:mm'));

    // Set page for add/edit
    if (this.editPushNotificationCampaignDetails) { // Edit
      this.pageMode = 'edit';
      this.pageTitle = 'Edit Push Notification Campaign';

      this.campaignName = this.editPushNotificationCampaignDetails.campaign_name;
      this.campaignDate = new Date(moment(this.editPushNotificationCampaignDetails.schedule_date).format('YYYY-MM-DD'));
      this.pushNotificationTitle = this.editPushNotificationCampaignDetails.title;
      this.pushNotificationMessage = this.editPushNotificationCampaignDetails.message;
      this.pushNotificationImage.file = '';
      this.pushNotificationImage.base64 = '';
      this.pushNotificationImage.s3FilePath = this.editPushNotificationCampaignDetails.image;
    } else { // Add
      this.pageMode = 'add';
      this.pageTitle = 'Create Push Notification Campaign';

      this.campaignName = '';
      this.campaignDate = new Date(moment().format('YYYY-MM-DD'));
      this.pushNotificationTitle = '';
      this.pushNotificationMessage = '';
      this.pushNotificationImage.file = '';
      this.pushNotificationImage.base64 = '';
      this.pushNotificationImage.s3FilePath = '';
    }

    // Get push notification topics
    this.pushNotificationTopicsLoading = true;
    this._pushNotificationService.getPushNotificationTopics(this.loginData.token, this.loginData.user_details.provider_id).subscribe(async getPushNotificationTopicsResponse => {
      this.pushNotificationTopicsLoading = false;

      if (getPushNotificationTopicsResponse.status === true) { // Success
        this.pushNotificationTopics = getPushNotificationTopicsResponse.push_notification_topics;
        
        if (this.editPushNotificationCampaignDetails) { // Edit
          let tempPushNotificationTopic = _.filter(this.pushNotificationTopics, obj => obj.topic_id == this.editPushNotificationCampaignDetails.campaign_topic_id);
          
          if (tempPushNotificationTopic.length > 0) {
            this.selectedPushNotificationTopic = tempPushNotificationTopic[0].topic_id; // Set selecdted campaign topic as default
          } else {
            this._utilService.showToast('Campaign topic not found', '', 'error', {});
          }
        } else { // Add
          this.selectedPushNotificationTopic = getPushNotificationTopicsResponse.push_notification_topics[0].topic_id; // Set first topic as default
        }
      } else {
        this._utilService.showToast(getPushNotificationTopicsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getPushNotificationTopics
      this.pushNotificationTopicsLoading = false;
    });
  }

  // Back to coupons report
  onBackClick(){
    this._router.navigate(['/retailer/push-notification-campaign'], {
      state: {}
    });
  }

  // Push notification topic change
  onPushNotificationTopicChange(event: any) {
  }

  // On calendar value change
  onCalendarValueChange(event: any) {
    // Update campaign date
    if (event) {
      this.campaignDate = event;
    }
  }

  // On image select
  onImageSelect(event: any) {
    let selectedFile: any = event.addedFiles[0];
    let selectedFileName: any = selectedFile.name.split('.');
    let selectedFileSize: any = selectedFile.size;

    if ((selectedFileSize / 1000) > 100) { // > 100 Kb
      this.pushNotificationImage.file = ''; // Reset
      this.pushNotificationImage.base64 = ''; // Reset
      this._utilService.showToast('Please select an image with size less than 100Kb', '', 'warning', {});
    } else if (selectedFileName.length > 2) {
      this.pushNotificationImage.file = ''; // Reset
      this.pushNotificationImage.base64 = ''; // Reset
      this._utilService.showToast("Image file name should not have '.' in it", '', 'warning', {});
    } else if (selectedFileName.length === 2 && (selectedFileName[1].toLowerCase() === "jpg" || selectedFileName[1].toLowerCase() === "jpeg" || selectedFileName[1].toLowerCase() === "png")) {
      this._utilService.imageFiletoBase64(selectedFile, 1024).then(fileContents => {
        this.pushNotificationImage.file = selectedFile;
        this.pushNotificationImage.base64 = fileContents; 
      }, error => {
        this._utilService.showToast(error, '', 'warning', {});
      });
    } else {
      this.pushNotificationImage.file = ''; // Reset
      this.pushNotificationImage.base64 = ''; // Reset
      this._utilService.showToast('Please select png or jpg image', '', 'warning', {});
    }
  }

  // Remove selected image
  removeSelectedImage(){
    this.pushNotificationImage.base64 = '';
  }

  // On save push notification campaign click
  onSavePushNotificationCampaignClick(template: TemplateRef<any>) {
    // Validations
    if(!this.campaignName) { // Campaign Name
      this._utilService.showToast('Please enter campaign name.', '', 'warning', {});
      return false;
    }

    if(!this.campaignDate) { // Campaign Date
      this._utilService.showToast('Please select campaign date.', '', 'warning', {});
      return false;
    }

    if(!this.selectedPushNotificationTopic) { // Target Users
      this._utilService.showToast('Please select target users.', '', 'warning', {});
      return false;
    }

    if(!this.pushNotificationTitle) { // Title
      this._utilService.showToast('Please enter push notification title.', '', 'warning', {});
      return false;
    } else if (this.pushNotificationTitle.length > 65) { 
      this._utilService.showToast('Push notification title should be less than or equal to 65 characters.', '', 'warning', {});
      return false;
    }

    if(!this.pushNotificationMessage) { // Message
      this._utilService.showToast('Please enter push notification message.', '', 'warning', {});
      return false;
    } else if (this.pushNotificationMessage.length > 240) { 
      this._utilService.showToast('Push notification message should be less than or equal to 240 characters.', '', 'warning', {});
      return false;
    }

    this.pushNotificationCampaignSaveConfirmModal = this._modalService.show(template, {ignoreBackdropClick: true});
  }

  // On delete push notification campaign click
  onDeletePushNotificationCampaignClick(template: TemplateRef<any>) {
    if (this.pageMode == 'edit') {
      this.isDeletePushNotificationCampaign = true; // Enable delete mode
      this.pushNotificationCampaignSaveConfirmModal = this._modalService.show(template, {ignoreBackdropClick: true});
    }
  }

  // Submit push notification campaign
  async submitPushNotificationCampaign() {
    this.savingPushNotificationCampaign = true;

    if (this.pushNotificationImage.file && this.pushNotificationImage.base64) { // New image file selected
      /*// Upload new image file and get s3 url
      let imageFolder: string = this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.s3_folder_push_notification_campaigns + '/';
      let imageUploadResponse: any = await this._utilService.s3Base64Upload(this.pushNotificationImage.file, this.pushNotificationImage.base64, environment.s3_bucket, imageFolder);

      if(imageUploadResponse.status == true){ // Upload success
        this.pushNotificationImage.s3FilePath = imageUploadResponse.location;
      } else { // Upload Error
        this._utilService.showToast('Error while uploading image', '', 'error', {});
        this.savingPushNotificationCampaign = false;
        return false;
      }*/

      // Upload file to cloud storage
      let imageFolder: string = environment.cloud_storage_folder_prefix + '/' + this.loginData.user_details.provider_type + this.loginData.user_details.provider_id + '/' + environment.cloud_storage_folder_push_notification_campaigns;
      let uploadFileBody: any = {
        bucket: environment.cloud_storage_bucket,
        folder: imageFolder,
        fileType: this.pushNotificationImage.file.type,
        base64Data: this.pushNotificationImage.base64
      }

      this._utilService.uploadFile(this.loginData.token, uploadFileBody).subscribe(async uploadFileResponse => {
        if (uploadFileResponse.status === true) { // Success
          this.pushNotificationImage.s3FilePath = uploadFileResponse.file_name;

          if (this.pageMode == 'add') {
            this.createPushNotificationCampaign();
          } else {
            this.updatePushNotificationCampaign();
          }
        } else {
          this._utilService.showToast('Error while uploading image', '', 'error', {});
          this.savingPushNotificationCampaign = false;
          return false;
        }
      }, error => { // Error from createCircular
        this._utilService.showToast('Error while uploading image', '', 'error', {});
        this.savingPushNotificationCampaign = false;
        return false;
      });
    }
  }

  // Create push notification campaign
  createPushNotificationCampaign() {
    try {
      let createPushNotificationCampaignBody: any = {
        retailer_id: this.loginData.user_details.provider_id,
        user_id: this.loginData.user_details.user_id,
        schedule_date: moment(this.campaignDate).format('YYYY-MM-DD') + ' 09:00:00.000', // 9 AM
        campaign_topic_id: this.selectedPushNotificationTopic,
        campaign_name: this.campaignName.replace("'","''''"),
        title: this.pushNotificationTitle.replace("'","''''"),
        message: this.pushNotificationMessage.replace("'","''''"),
        image: this.pushNotificationImage.s3FilePath
      }
      
      this._pushNotificationService.createPushNotificationCampaign(this.loginData.token, createPushNotificationCampaignBody).subscribe(async createPushNotificationCampaignResponse => {
        this.savingPushNotificationCampaign = false;

        if (createPushNotificationCampaignResponse.status === true) { // Success
          this.hidePushNotificationCampaignSaveConfirmModal(); // Close modal

          this._utilService.showToast('Push notification campaign created successfully.', '', 'success', {});
          this._router.navigate(['/retailer/push-notification-campaign']); // Go to push notification campaign list
        } else {
          this._utilService.showToast(createPushNotificationCampaignResponse.message, '', 'error', {});
        }
      }, error => { // Error from createPushNotificationCampaign
        this.savingPushNotificationCampaign = false;
      });
    } catch (err) {
      this.savingPushNotificationCampaign = false;
      this._utilService.showToast('Error while creating push notification campaign.', '', 'error', {});
    }
  }

  // Update push notification campaign
  updatePushNotificationCampaign() {
    try {
      let updatePushNotificationCampaignBody: any = {
        campaign_id: this.editPushNotificationCampaignDetails.campaign_id,
        retailer_id: this.editPushNotificationCampaignDetails.retailer_id,
        user_id: this.loginData.user_details.user_id,
        schedule_date: moment(this.campaignDate).format('YYYY-MM-DD') + ' 09:00:00.000', // 9 AM
        campaign_topic_id: this.selectedPushNotificationTopic,
        campaign_name: this.campaignName.replace("'","''''"),
        title: this.pushNotificationTitle.replace("'","''''"),
        message: this.pushNotificationMessage.replace("'","''''"),
        image: this.pushNotificationImage.s3FilePath
      }

      this._pushNotificationService.updatePushNotificationCampaign(this.loginData.token, updatePushNotificationCampaignBody).subscribe(async updatePushNotificationCampaignResponse => {
        this.savingPushNotificationCampaign = false;

        if (updatePushNotificationCampaignResponse.status === true) { // Success
          this.hidePushNotificationCampaignSaveConfirmModal(); // Close modal

          this._utilService.showToast('Push notification campaign updated successfully.', '', 'success', {});
          this._router.navigate(['/retailer/push-notification-campaign']); // Go to push notification campaign list
        } else {
          this._utilService.showToast(updatePushNotificationCampaignResponse.message, '', 'error', {});
        }
      }, error => { // Error from updatePushNotificationCampaign
        this.savingPushNotificationCampaign = false;
      });
    } catch (err) {
      this.savingPushNotificationCampaign = false;
      this._utilService.showToast('Error while updating push notification campaign.', '', 'error', {});
    }
  }

  // Delete push notification campaign
  async deletePushNotificationCampaign() {
    this.savingPushNotificationCampaign = true;

    let cancelPushNotificationCampaignBody: any = {
      campaign_id: this.editPushNotificationCampaignDetails.campaign_id,
      retailer_id: this.loginData.user_details.provider_id,
      user_id: this.loginData.user_details.user_id
    }

    this._pushNotificationService.cancelPushNotificationCampaign(this.loginData.token, cancelPushNotificationCampaignBody).subscribe(async cancelPushNotificationCampaignResponse => {
      this.savingPushNotificationCampaign = false;

      if (cancelPushNotificationCampaignResponse.status === true) { // Success
        this.hidePushNotificationCampaignSaveConfirmModal(); // Close modal

        this._utilService.showToast('Push notification campaign deleted successfully.', '', 'success', {});
        this._router.navigate(['/retailer/push-notification-campaign']); // Go to push notification campaign list
      } else {
        this._utilService.showToast(cancelPushNotificationCampaignResponse.message, '', 'error', {});
      }
    }, error => { // Error from cancelSMSCampaign
      this.savingPushNotificationCampaign = false;
    });
  }

  // Hide push notification campaign save confirm modal
  hidePushNotificationCampaignSaveConfirmModal(): void {
    this.isDeletePushNotificationCampaign = false; // Disable delete mode
    this.pushNotificationCampaignSaveConfirmModal.hide();
  }

}
